/* app/js/src/components/export-platforms/export-platforms.scss */
.cursor-pointer {
  cursor: pointer;
}
.container::-webkit-scrollbar {
  height: 11px;
  overflow: visible;
  width: 11px;
  opacity: 1;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.container::-webkit-scrollbar-button {
  height: 0;
  width: 0;
}
.container::-webkit-scrollbar-corner {
  background: transparent;
}
.container::-webkit-scrollbar-thumb:hover {
  background-color: #b9bec9;
}
.container::-webkit-scrollbar-thumb {
  background-color: #e3e6ea;
  background-clip: padding-box;
  border: solid transparent;
  border-width: 0 4px 0 4px;
  min-height: 28px;
  padding: 100px 0 0;
  border-radius: 10px;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.container::-webkit-scrollbar-thumb:hover {
  background-color: #b9bec9;
}
.container::-webkit-scrollbar-track:hover {
  background-color: #eef2f6;
}
.container::-webkit-scrollbar-track {
  background-clip: padding-box;
  border: solid transparent;
  border-width: 0 4px 0 4px;
}
.btn-save {
  display: inline-block;
  color: #ffffff;
  border-radius: 4px;
  background-color: #232f3a;
  padding: 6px 9px 6px 9px;
  font-size: 0.85em;
  border: 1px solid #879baf;
  cursor: pointer;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.btn-save:focus {
  outline-color: #ffffff;
}
.btn-save:hover {
  background-color: white;
  color: #232f3a;
}
.disabled.btn-save {
  color: #879baf;
  background-color: #dde3e7;
  border-color: #dde3e7;
  cursor: auto;
}
.platforms-container {
  width: 500px;
  height: 480px;
  background-color: white;
  border-radius: 4px;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.2);
  border: solid 1px #e1e6eb;
  padding: 25px 37px;
}
.platforms-header {
  margin-bottom: 12px;
}
.add-platform-header {
  font-family: "Open Sans";
  font-size: 20px;
  color: #232f3a;
  margin-right: 185px;
}
.platform-label {
  font-family: "Open Sans";
  font-size: 12px;
  color: #7d8fa1;
  display: inline-block;
  margin-right: 10px;
}
icn-dropdown {
  width: 112px;
}
.platforms-name {
  margin-bottom: 30px;
}
.platform-name-input {
  height: 30px;
  width: 382px;
  border-radius: 4px;
  border: solid 1px #e1e6eb;
  display: inline-block;
  line-height: 5em;
  padding-left: 14px;
}
input::-webkit-input-placeholder {
  font-family: "Open Sans";
  font-size: 12px;
  color: #c9cdd6;
}
.export-fields-header {
  font-family: "Open Sans";
  font-size: 14px;
  color: #232f3a;
}
.wrapper {
  display: flex;
  flex-direction: row;
  margin-top: 30px;
}
.container {
  overflow-y: scroll;
  height: 185px;
  width: 187px;
  border: solid 1px #e1e6eb;
  color: #7d8fa1;
  border-radius: 4px;
}
.container > div {
  font-family: "Open Sans";
  font-size: 14px;
  color: #7d8fa1;
  border-bottom: solid 1px rgba(201, 205, 214, 0.3);
  padding: 7px;
}
.container > div:hover {
  cursor: pointer;
  color: #232f3a;
  background-color: #f1f3f4;
}
.container-left {
  margin-right: 25px;
}
.container-right {
  margin-left: 25px;
}
.btn-save {
  margin-top: 30px;
  position: absolute;
  left: 417px;
  top: 410px;
}
/*# sourceMappingURL=export-platforms.css.map */
